import type { DefaultAvatarType } from './resolveAvatarType';
import { resolveAvatarType } from './resolveAvatarType';
import { Type } from '../types/SharedPropTypes';

export const getDefaultAvatarType = (
  type?: Type
): DefaultAvatarType | undefined => {
  return resolveAvatarType(type)?.defaultAvatarType;
};
